import { render, staticRenderFns } from "./MerchandiserView.vue?vue&type=template&id=4c748693&scoped=true&"
import script from "./MerchandiserView.vue?vue&type=script&lang=js&"
export * from "./MerchandiserView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c748693",
  null
  
)

export default component.exports